export const roadmapQuarters = ["1", "2", "3", "4"];

export function quarterDates(year: number, start: number, end: number) {
  const prefix = String(year).padStart(4, "0");
  return {
    startDate: `${prefix}-${String(start * 3 - 2).padStart(2, "0")}-01`,
    endDate: `${prefix}-${["03-31", "06-30", "09-30", "12-31"][end - 1]}`,
  };
}
